/**
 * Do not edit directly
 * Generated on Wed, 07 Sep 2022 22:01:12 GMT
 */

module.exports = {
  "border": {
    "round": {
      "hairline": {
        "radius": {
          "value": "4px",
          "filePath": "tokens/base/border.json",
          "isSource": true,
          "original": {
            "value": "4px"
          },
          "name": "BorderRoundHairlineRadius",
          "attributes": {
            "category": "border",
            "type": "round",
            "item": "hairline",
            "subitem": "radius"
          },
          "path": [
            "border",
            "round",
            "hairline",
            "radius"
          ]
        },
        "width": {
          "value": "1px",
          "filePath": "tokens/base/border.json",
          "isSource": true,
          "original": {
            "value": "1px"
          },
          "name": "BorderRoundHairlineWidth",
          "attributes": {
            "category": "border",
            "type": "round",
            "item": "hairline",
            "subitem": "width"
          },
          "path": [
            "border",
            "round",
            "hairline",
            "width"
          ]
        }
      },
      "radius": {
        "value": "4px",
        "filePath": "tokens/base/border.json",
        "isSource": true,
        "original": {
          "value": "4px"
        },
        "name": "BorderRoundRadius",
        "attributes": {
          "category": "border",
          "type": "round",
          "item": "radius"
        },
        "path": [
          "border",
          "round",
          "radius"
        ]
      },
      "width": {
        "value": "2px",
        "filePath": "tokens/base/border.json",
        "isSource": true,
        "original": {
          "value": "2px"
        },
        "name": "BorderRoundWidth",
        "attributes": {
          "category": "border",
          "type": "round",
          "item": "width"
        },
        "path": [
          "border",
          "round",
          "width"
        ]
      }
    }
  },
  "color": {
    "brand": {
      "dust": {
        "value": "#f2ebe4",
        "filePath": "tokens/base/color.json",
        "isSource": true,
        "original": {
          "value": "#F2EBE4"
        },
        "name": "ColorBrandDust",
        "attributes": {
          "category": "color",
          "type": "brand",
          "item": "dust"
        },
        "path": [
          "color",
          "brand",
          "dust"
        ]
      },
      "asphalt": {
        "v40": {
          "value": "#a4abb4",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#A4ABB4"
          },
          "name": "ColorBrandAsphaltV40",
          "attributes": {
            "category": "color",
            "type": "brand",
            "item": "asphalt",
            "subitem": "v40"
          },
          "path": [
            "color",
            "brand",
            "asphalt",
            "v40"
          ]
        },
        "v50": {
          "value": "#595f69",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#595f69"
          },
          "name": "ColorBrandAsphaltV50",
          "attributes": {
            "category": "color",
            "type": "brand",
            "item": "asphalt",
            "subitem": "v50"
          },
          "path": [
            "color",
            "brand",
            "asphalt",
            "v50"
          ]
        },
        "v60": {
          "value": "#191919",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#191919"
          },
          "name": "ColorBrandAsphaltV60",
          "attributes": {
            "category": "color",
            "type": "brand",
            "item": "asphalt",
            "subitem": "v60"
          },
          "path": [
            "color",
            "brand",
            "asphalt",
            "v60"
          ]
        }
      },
      "green": {
        "v40": {
          "value": "#d9e670",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#D9E670"
          },
          "name": "ColorBrandGreenV40",
          "attributes": {
            "category": "color",
            "type": "brand",
            "item": "green",
            "subitem": "v40"
          },
          "path": [
            "color",
            "brand",
            "green",
            "v40"
          ]
        },
        "v60": {
          "value": "#373a25",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#373A25"
          },
          "name": "ColorBrandGreenV60",
          "attributes": {
            "category": "color",
            "type": "brand",
            "item": "green",
            "subitem": "v60"
          },
          "path": [
            "color",
            "brand",
            "green",
            "v60"
          ]
        }
      },
      "copper": {
        "v40": {
          "value": "#cf8c29",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#CF8C29"
          },
          "name": "ColorBrandCopperV40",
          "attributes": {
            "category": "color",
            "type": "brand",
            "item": "copper",
            "subitem": "v40"
          },
          "path": [
            "color",
            "brand",
            "copper",
            "v40"
          ]
        },
        "v60": {
          "value": "#432706",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#432706"
          },
          "name": "ColorBrandCopperV60",
          "attributes": {
            "category": "color",
            "type": "brand",
            "item": "copper",
            "subitem": "v60"
          },
          "path": [
            "color",
            "brand",
            "copper",
            "v60"
          ]
        }
      },
      "magenta": {
        "v40": {
          "value": "#f10251",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#F10251"
          },
          "name": "ColorBrandMagentaV40",
          "attributes": {
            "category": "color",
            "type": "brand",
            "item": "magenta",
            "subitem": "v40"
          },
          "path": [
            "color",
            "brand",
            "magenta",
            "v40"
          ]
        },
        "v60": {
          "value": "#341624",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#341624"
          },
          "name": "ColorBrandMagentaV60",
          "attributes": {
            "category": "color",
            "type": "brand",
            "item": "magenta",
            "subitem": "v60"
          },
          "path": [
            "color",
            "brand",
            "magenta",
            "v60"
          ]
        }
      },
      "orange": {
        "v40": {
          "value": "#ff5132",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#ff5132"
          },
          "name": "ColorBrandOrangeV40",
          "attributes": {
            "category": "color",
            "type": "brand",
            "item": "orange",
            "subitem": "v40"
          },
          "path": [
            "color",
            "brand",
            "orange",
            "v40"
          ]
        },
        "v60": {
          "value": "#4d1906",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#4D1906"
          },
          "name": "ColorBrandOrangeV60",
          "attributes": {
            "category": "color",
            "type": "brand",
            "item": "orange",
            "subitem": "v60"
          },
          "path": [
            "color",
            "brand",
            "orange",
            "v60"
          ]
        }
      }
    },
    "base": {
      "white": {
        "value": "#ffffff",
        "filePath": "tokens/base/color.json",
        "isSource": true,
        "original": {
          "value": "#FFFFFF"
        },
        "name": "ColorBaseWhite",
        "attributes": {
          "category": "color",
          "type": "base",
          "item": "white"
        },
        "path": [
          "color",
          "base",
          "white"
        ]
      },
      "black": {
        "value": "#000000",
        "filePath": "tokens/base/color.json",
        "isSource": true,
        "original": {
          "value": "#000000"
        },
        "name": "ColorBaseBlack",
        "attributes": {
          "category": "color",
          "type": "base",
          "item": "black"
        },
        "path": [
          "color",
          "base",
          "black"
        ]
      },
      "blue": {
        "v500": {
          "value": "#005176",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#005176"
          },
          "name": "ColorBaseBlueV500",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "blue",
            "subitem": "v500"
          },
          "path": [
            "color",
            "base",
            "blue",
            "v500"
          ]
        },
        "v300": {
          "value": "#4dc2f6",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#4DC2F6"
          },
          "name": "ColorBaseBlueV300",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "blue",
            "subitem": "v300"
          },
          "path": [
            "color",
            "base",
            "blue",
            "v300"
          ]
        },
        "v100": {
          "value": "#a0bdf8",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#A0BDF8"
          },
          "name": "ColorBaseBlueV100",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "blue",
            "subitem": "v100"
          },
          "path": [
            "color",
            "base",
            "blue",
            "v100"
          ]
        },
        "v50": {
          "value": "#e7efff",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#E7EFFF"
          },
          "name": "ColorBaseBlueV50",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "blue",
            "subitem": "v50"
          },
          "path": [
            "color",
            "base",
            "blue",
            "v50"
          ]
        }
      },
      "green": {
        "v500": {
          "value": "#00762b",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#00762B"
          },
          "name": "ColorBaseGreenV500",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "green",
            "subitem": "v500"
          },
          "path": [
            "color",
            "base",
            "green",
            "v500"
          ]
        },
        "v300": {
          "value": "#22c55e",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#22C55E"
          },
          "name": "ColorBaseGreenV300",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "green",
            "subitem": "v300"
          },
          "path": [
            "color",
            "base",
            "green",
            "v300"
          ]
        },
        "v100": {
          "value": "#9adebd",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#9ADEBD"
          },
          "name": "ColorBaseGreenV100",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "green",
            "subitem": "v100"
          },
          "path": [
            "color",
            "base",
            "green",
            "v100"
          ]
        },
        "v50": {
          "value": "#eaf8f1",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#EAF8F1"
          },
          "name": "ColorBaseGreenV50",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "green",
            "subitem": "v50"
          },
          "path": [
            "color",
            "base",
            "green",
            "v50"
          ]
        }
      },
      "red": {
        "v500": {
          "value": "#bf1313",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#BF1313"
          },
          "name": "ColorBaseRedV500",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "red",
            "subitem": "v500"
          },
          "path": [
            "color",
            "base",
            "red",
            "v500"
          ]
        },
        "v300": {
          "value": "#ef4444",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#EF4444"
          },
          "name": "ColorBaseRedV300",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "red",
            "subitem": "v300"
          },
          "path": [
            "color",
            "base",
            "red",
            "v300"
          ]
        },
        "v100": {
          "value": "#eca9a3",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#ECA9A3"
          },
          "name": "ColorBaseRedV100",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "red",
            "subitem": "v100"
          },
          "path": [
            "color",
            "base",
            "red",
            "v100"
          ]
        },
        "v50": {
          "value": "#fae0e0",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#FAE0E0"
          },
          "name": "ColorBaseRedV50",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "red",
            "subitem": "v50"
          },
          "path": [
            "color",
            "base",
            "red",
            "v50"
          ]
        }
      },
      "orange": {
        "v500": {
          "value": "#b04e07",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#B04E07"
          },
          "name": "ColorBaseOrangeV500",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "orange",
            "subitem": "v500"
          },
          "path": [
            "color",
            "base",
            "orange",
            "v500"
          ]
        },
        "v300": {
          "value": "#f97316",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#F97316"
          },
          "name": "ColorBaseOrangeV300",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "orange",
            "subitem": "v300"
          },
          "path": [
            "color",
            "base",
            "orange",
            "v300"
          ]
        },
        "v100": {
          "value": "#ffbb8c",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#FFBB8C"
          },
          "name": "ColorBaseOrangeV100",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "orange",
            "subitem": "v100"
          },
          "path": [
            "color",
            "base",
            "orange",
            "v100"
          ]
        },
        "v50": {
          "value": "#ffe8d8",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#FFE8D8"
          },
          "name": "ColorBaseOrangeV50",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "orange",
            "subitem": "v50"
          },
          "path": [
            "color",
            "base",
            "orange",
            "v50"
          ]
        }
      },
      "yellow": {
        "v500": {
          "value": "#826811",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#826811"
          },
          "name": "ColorBaseYellowV500",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "yellow",
            "subitem": "v500"
          },
          "path": [
            "color",
            "base",
            "yellow",
            "v500"
          ]
        },
        "v300": {
          "value": "#eab308",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#EAB308"
          },
          "name": "ColorBaseYellowV300",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "yellow",
            "subitem": "v300"
          },
          "path": [
            "color",
            "base",
            "yellow",
            "v300"
          ]
        },
        "v100": {
          "value": "#ffe68c",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#FFE68C"
          },
          "name": "ColorBaseYellowV100",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "yellow",
            "subitem": "v100"
          },
          "path": [
            "color",
            "base",
            "yellow",
            "v100"
          ]
        },
        "v50": {
          "value": "#fef8e1",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#FEF8E1"
          },
          "name": "ColorBaseYellowV50",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "yellow",
            "subitem": "v50"
          },
          "path": [
            "color",
            "base",
            "yellow",
            "v50"
          ]
        }
      },
      "purple": {
        "v500": {
          "value": "#6000ba",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#6000BA"
          },
          "name": "ColorBasePurpleV500",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "purple",
            "subitem": "v500"
          },
          "path": [
            "color",
            "base",
            "purple",
            "v500"
          ]
        },
        "v300": {
          "value": "#a855f7",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#A855F7"
          },
          "name": "ColorBasePurpleV300",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "purple",
            "subitem": "v300"
          },
          "path": [
            "color",
            "base",
            "purple",
            "v300"
          ]
        },
        "v100": {
          "value": "#beacf0",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#BEACF0"
          },
          "name": "ColorBasePurpleV100",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "purple",
            "subitem": "v100"
          },
          "path": [
            "color",
            "base",
            "purple",
            "v100"
          ]
        },
        "v50": {
          "value": "#ede7ff",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#EDE7FF"
          },
          "name": "ColorBasePurpleV50",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "purple",
            "subitem": "v50"
          },
          "path": [
            "color",
            "base",
            "purple",
            "v50"
          ]
        }
      },
      "digitalSecondary": {
        "v300": {
          "value": "#0a7db3",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#0A7DB3"
          },
          "name": "ColorBaseDigitalSecondaryV300",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "digitalSecondary",
            "subitem": "v300"
          },
          "path": [
            "color",
            "base",
            "digitalSecondary",
            "v300"
          ]
        }
      },
      "gray": {
        "v900": {
          "value": "#09091a",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#09091A"
          },
          "name": "ColorBaseGrayV900",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "gray",
            "subitem": "v900"
          },
          "path": [
            "color",
            "base",
            "gray",
            "v900"
          ]
        },
        "v800": {
          "value": "#25252c",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#25252C"
          },
          "name": "ColorBaseGrayV800",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "gray",
            "subitem": "v800"
          },
          "path": [
            "color",
            "base",
            "gray",
            "v800"
          ]
        },
        "v700": {
          "value": "#313140",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#313140"
          },
          "name": "ColorBaseGrayV700",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "gray",
            "subitem": "v700"
          },
          "path": [
            "color",
            "base",
            "gray",
            "v700"
          ]
        },
        "v600": {
          "value": "#3f4055",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#3F4055"
          },
          "name": "ColorBaseGrayV600",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "gray",
            "subitem": "v600"
          },
          "path": [
            "color",
            "base",
            "gray",
            "v600"
          ]
        },
        "v500": {
          "value": "#515369",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#515369"
          },
          "name": "ColorBaseGrayV500",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "gray",
            "subitem": "v500"
          },
          "path": [
            "color",
            "base",
            "gray",
            "v500"
          ]
        },
        "v400": {
          "value": "#66687d",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#66687D"
          },
          "name": "ColorBaseGrayV400",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "gray",
            "subitem": "v400"
          },
          "path": [
            "color",
            "base",
            "gray",
            "v400"
          ]
        },
        "v300": {
          "value": "#7b7e91",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#7B7E91"
          },
          "name": "ColorBaseGrayV300",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "gray",
            "subitem": "v300"
          },
          "path": [
            "color",
            "base",
            "gray",
            "v300"
          ]
        },
        "v200": {
          "value": "#9295a6",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#9295A6"
          },
          "name": "ColorBaseGrayV200",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "gray",
            "subitem": "v200"
          },
          "path": [
            "color",
            "base",
            "gray",
            "v200"
          ]
        },
        "v100": {
          "value": "#abadba",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#ABADBA"
          },
          "name": "ColorBaseGrayV100",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "gray",
            "subitem": "v100"
          },
          "path": [
            "color",
            "base",
            "gray",
            "v100"
          ]
        },
        "v75": {
          "value": "#d7dae2",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#D7DAE2"
          },
          "name": "ColorBaseGrayV75",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "gray",
            "subitem": "v75"
          },
          "path": [
            "color",
            "base",
            "gray",
            "v75"
          ]
        },
        "v50": {
          "value": "#e9ecf3",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#E9ECF3"
          },
          "name": "ColorBaseGrayV50",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "gray",
            "subitem": "v50"
          },
          "path": [
            "color",
            "base",
            "gray",
            "v50"
          ]
        },
        "v25": {
          "value": "#f9fbff",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#F9FBFF"
          },
          "name": "ColorBaseGrayV25",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "gray",
            "subitem": "v25"
          },
          "path": [
            "color",
            "base",
            "gray",
            "v25"
          ]
        }
      },
      "graySemantic": {
        "v500": {
          "value": "#384152",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#384152"
          },
          "name": "ColorBaseGraySemanticV500",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "graySemantic",
            "subitem": "v500"
          },
          "path": [
            "color",
            "base",
            "graySemantic",
            "v500"
          ]
        },
        "v300": {
          "value": "#697a99",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#697A99"
          },
          "name": "ColorBaseGraySemanticV300",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "graySemantic",
            "subitem": "v300"
          },
          "path": [
            "color",
            "base",
            "graySemantic",
            "v300"
          ]
        },
        "v100": {
          "value": "#afb6c3",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#AFB6C3"
          },
          "name": "ColorBaseGraySemanticV100",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "graySemantic",
            "subitem": "v100"
          },
          "path": [
            "color",
            "base",
            "graySemantic",
            "v100"
          ]
        },
        "v50": {
          "value": "#e9edf3",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#E9EDF3"
          },
          "name": "ColorBaseGraySemanticV50",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "graySemantic",
            "subitem": "v50"
          },
          "path": [
            "color",
            "base",
            "graySemantic",
            "v50"
          ]
        }
      }
    }
  },
  "font": {
    "b100": {
      "family": {
        "value": "Inter UI",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "Inter UI"
        },
        "name": "FontB100Family",
        "attributes": {
          "category": "font",
          "type": "b100",
          "item": "family"
        },
        "path": [
          "font",
          "b100",
          "family"
        ]
      },
      "size": {
        "value": "10px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "10px"
        },
        "name": "FontB100Size",
        "attributes": {
          "category": "font",
          "type": "b100",
          "item": "size"
        },
        "path": [
          "font",
          "b100",
          "size"
        ]
      },
      "weight": {
        "value": "500",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "500"
        },
        "name": "FontB100Weight",
        "attributes": {
          "category": "font",
          "type": "b100",
          "item": "weight"
        },
        "path": [
          "font",
          "b100",
          "weight"
        ]
      },
      "lineHeight": {
        "value": "13px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "13px"
        },
        "name": "FontB100LineHeight",
        "attributes": {
          "category": "font",
          "type": "b100",
          "item": "lineHeight"
        },
        "path": [
          "font",
          "b100",
          "lineHeight"
        ]
      },
      "letterSpacing": {
        "value": "0.25px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "0.25px"
        },
        "name": "FontB100LetterSpacing",
        "attributes": {
          "category": "font",
          "type": "b100",
          "item": "letterSpacing"
        },
        "path": [
          "font",
          "b100",
          "letterSpacing"
        ]
      }
    },
    "b200": {
      "family": {
        "value": "Inter UI",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "Inter UI"
        },
        "name": "FontB200Family",
        "attributes": {
          "category": "font",
          "type": "b200",
          "item": "family"
        },
        "path": [
          "font",
          "b200",
          "family"
        ]
      },
      "size": {
        "value": "12px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "12px"
        },
        "name": "FontB200Size",
        "attributes": {
          "category": "font",
          "type": "b200",
          "item": "size"
        },
        "path": [
          "font",
          "b200",
          "size"
        ]
      },
      "weight": {
        "value": "400",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "400"
        },
        "name": "FontB200Weight",
        "attributes": {
          "category": "font",
          "type": "b200",
          "item": "weight"
        },
        "path": [
          "font",
          "b200",
          "weight"
        ]
      },
      "lineHeight": {
        "value": "16px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "16px"
        },
        "name": "FontB200LineHeight",
        "attributes": {
          "category": "font",
          "type": "b200",
          "item": "lineHeight"
        },
        "path": [
          "font",
          "b200",
          "lineHeight"
        ]
      },
      "letterSpacing": {
        "value": "0",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "0"
        },
        "name": "FontB200LetterSpacing",
        "attributes": {
          "category": "font",
          "type": "b200",
          "item": "letterSpacing"
        },
        "path": [
          "font",
          "b200",
          "letterSpacing"
        ]
      }
    },
    "b300": {
      "family": {
        "value": "Inter UI",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "Inter UI"
        },
        "name": "FontB300Family",
        "attributes": {
          "category": "font",
          "type": "b300",
          "item": "family"
        },
        "path": [
          "font",
          "b300",
          "family"
        ]
      },
      "size": {
        "value": "14px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "14px"
        },
        "name": "FontB300Size",
        "attributes": {
          "category": "font",
          "type": "b300",
          "item": "size"
        },
        "path": [
          "font",
          "b300",
          "size"
        ]
      },
      "weight": {
        "value": "400",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "400"
        },
        "name": "FontB300Weight",
        "attributes": {
          "category": "font",
          "type": "b300",
          "item": "weight"
        },
        "path": [
          "font",
          "b300",
          "weight"
        ]
      },
      "lineHeight": {
        "value": "19px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "19px"
        },
        "name": "FontB300LineHeight",
        "attributes": {
          "category": "font",
          "type": "b300",
          "item": "lineHeight"
        },
        "path": [
          "font",
          "b300",
          "lineHeight"
        ]
      },
      "letterSpacing": {
        "value": "-.50px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "-.50px"
        },
        "name": "FontB300LetterSpacing",
        "attributes": {
          "category": "font",
          "type": "b300",
          "item": "letterSpacing"
        },
        "path": [
          "font",
          "b300",
          "letterSpacing"
        ]
      }
    },
    "b400": {
      "family": {
        "value": "Inter UI",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "Inter UI"
        },
        "name": "FontB400Family",
        "attributes": {
          "category": "font",
          "type": "b400",
          "item": "family"
        },
        "path": [
          "font",
          "b400",
          "family"
        ]
      },
      "size": {
        "value": "16px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "16px"
        },
        "name": "FontB400Size",
        "attributes": {
          "category": "font",
          "type": "b400",
          "item": "size"
        },
        "path": [
          "font",
          "b400",
          "size"
        ]
      },
      "weight": {
        "value": "400",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "400"
        },
        "name": "FontB400Weight",
        "attributes": {
          "category": "font",
          "type": "b400",
          "item": "weight"
        },
        "path": [
          "font",
          "b400",
          "weight"
        ]
      },
      "lineHeight": {
        "value": "22px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "22px"
        },
        "name": "FontB400LineHeight",
        "attributes": {
          "category": "font",
          "type": "b400",
          "item": "lineHeight"
        },
        "path": [
          "font",
          "b400",
          "lineHeight"
        ]
      },
      "letterSpacing": {
        "value": "-.85px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "-.85px"
        },
        "name": "FontB400LetterSpacing",
        "attributes": {
          "category": "font",
          "type": "b400",
          "item": "letterSpacing"
        },
        "path": [
          "font",
          "b400",
          "letterSpacing"
        ]
      }
    },
    "b500": {
      "family": {
        "value": "Inter UI",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "Inter UI"
        },
        "name": "FontB500Family",
        "attributes": {
          "category": "font",
          "type": "b500",
          "item": "family"
        },
        "path": [
          "font",
          "b500",
          "family"
        ]
      },
      "size": {
        "value": "18px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "18px"
        },
        "name": "FontB500Size",
        "attributes": {
          "category": "font",
          "type": "b500",
          "item": "size"
        },
        "path": [
          "font",
          "b500",
          "size"
        ]
      },
      "weight": {
        "value": "500",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "500"
        },
        "name": "FontB500Weight",
        "attributes": {
          "category": "font",
          "type": "b500",
          "item": "weight"
        },
        "path": [
          "font",
          "b500",
          "weight"
        ]
      },
      "lineHeight": {
        "value": "24px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "24px"
        },
        "name": "FontB500LineHeight",
        "attributes": {
          "category": "font",
          "type": "b500",
          "item": "lineHeight"
        },
        "path": [
          "font",
          "b500",
          "lineHeight"
        ]
      },
      "letterSpacing": {
        "value": "-.75px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "-.75px"
        },
        "name": "FontB500LetterSpacing",
        "attributes": {
          "category": "font",
          "type": "b500",
          "item": "letterSpacing"
        },
        "path": [
          "font",
          "b500",
          "letterSpacing"
        ]
      }
    },
    "b600": {
      "family": {
        "value": "Inter UI",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "Inter UI"
        },
        "name": "FontB600Family",
        "attributes": {
          "category": "font",
          "type": "b600",
          "item": "family"
        },
        "path": [
          "font",
          "b600",
          "family"
        ]
      },
      "size": {
        "value": "21px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "21px"
        },
        "name": "FontB600Size",
        "attributes": {
          "category": "font",
          "type": "b600",
          "item": "size"
        },
        "path": [
          "font",
          "b600",
          "size"
        ]
      },
      "weight": {
        "value": "600",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "600"
        },
        "name": "FontB600Weight",
        "attributes": {
          "category": "font",
          "type": "b600",
          "item": "weight"
        },
        "path": [
          "font",
          "b600",
          "weight"
        ]
      },
      "lineHeight": {
        "value": "28px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "28px"
        },
        "name": "FontB600LineHeight",
        "attributes": {
          "category": "font",
          "type": "b600",
          "item": "lineHeight"
        },
        "path": [
          "font",
          "b600",
          "lineHeight"
        ]
      },
      "letterSpacing": {
        "value": "-.50px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "-.50px"
        },
        "name": "FontB600LetterSpacing",
        "attributes": {
          "category": "font",
          "type": "b600",
          "item": "letterSpacing"
        },
        "path": [
          "font",
          "b600",
          "letterSpacing"
        ]
      }
    },
    "b700": {
      "family": {
        "value": "Inter UI",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "Inter UI"
        },
        "name": "FontB700Family",
        "attributes": {
          "category": "font",
          "type": "b700",
          "item": "family"
        },
        "path": [
          "font",
          "b700",
          "family"
        ]
      },
      "size": {
        "value": "24px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "24px"
        },
        "name": "FontB700Size",
        "attributes": {
          "category": "font",
          "type": "b700",
          "item": "size"
        },
        "path": [
          "font",
          "b700",
          "size"
        ]
      },
      "weight": {
        "value": "600",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "600"
        },
        "name": "FontB700Weight",
        "attributes": {
          "category": "font",
          "type": "b700",
          "item": "weight"
        },
        "path": [
          "font",
          "b700",
          "weight"
        ]
      },
      "lineHeight": {
        "value": "32px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "32px"
        },
        "name": "FontB700LineHeight",
        "attributes": {
          "category": "font",
          "type": "b700",
          "item": "lineHeight"
        },
        "path": [
          "font",
          "b700",
          "lineHeight"
        ]
      },
      "letterSpacing": {
        "value": "-.25px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "-.25px"
        },
        "name": "FontB700LetterSpacing",
        "attributes": {
          "category": "font",
          "type": "b700",
          "item": "letterSpacing"
        },
        "path": [
          "font",
          "b700",
          "letterSpacing"
        ]
      }
    },
    "b800": {
      "family": {
        "value": "Inter UI",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "Inter UI"
        },
        "name": "FontB800Family",
        "attributes": {
          "category": "font",
          "type": "b800",
          "item": "family"
        },
        "path": [
          "font",
          "b800",
          "family"
        ]
      },
      "size": {
        "value": "32px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "32px"
        },
        "name": "FontB800Size",
        "attributes": {
          "category": "font",
          "type": "b800",
          "item": "size"
        },
        "path": [
          "font",
          "b800",
          "size"
        ]
      },
      "weight": {
        "value": "700",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "700"
        },
        "name": "FontB800Weight",
        "attributes": {
          "category": "font",
          "type": "b800",
          "item": "weight"
        },
        "path": [
          "font",
          "b800",
          "weight"
        ]
      },
      "lineHeight": {
        "value": "40px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "40px"
        },
        "name": "FontB800LineHeight",
        "attributes": {
          "category": "font",
          "type": "b800",
          "item": "lineHeight"
        },
        "path": [
          "font",
          "b800",
          "lineHeight"
        ]
      },
      "letterSpacing": {
        "value": "0",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "0"
        },
        "name": "FontB800LetterSpacing",
        "attributes": {
          "category": "font",
          "type": "b800",
          "item": "letterSpacing"
        },
        "path": [
          "font",
          "b800",
          "letterSpacing"
        ]
      }
    },
    "b900": {
      "family": {
        "value": "Inter UI",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "Inter UI"
        },
        "name": "FontB900Family",
        "attributes": {
          "category": "font",
          "type": "b900",
          "item": "family"
        },
        "path": [
          "font",
          "b900",
          "family"
        ]
      },
      "size": {
        "value": "48px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "48px"
        },
        "name": "FontB900Size",
        "attributes": {
          "category": "font",
          "type": "b900",
          "item": "size"
        },
        "path": [
          "font",
          "b900",
          "size"
        ]
      },
      "weight": {
        "value": "800",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "800"
        },
        "name": "FontB900Weight",
        "attributes": {
          "category": "font",
          "type": "b900",
          "item": "weight"
        },
        "path": [
          "font",
          "b900",
          "weight"
        ]
      },
      "lineHeight": {
        "value": "60px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "60px"
        },
        "name": "FontB900LineHeight",
        "attributes": {
          "category": "font",
          "type": "b900",
          "item": "lineHeight"
        },
        "path": [
          "font",
          "b900",
          "lineHeight"
        ]
      },
      "letterSpacing": {
        "value": ".25px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": ".25px"
        },
        "name": "FontB900LetterSpacing",
        "attributes": {
          "category": "font",
          "type": "b900",
          "item": "letterSpacing"
        },
        "path": [
          "font",
          "b900",
          "letterSpacing"
        ]
      }
    },
    "h70": {
      "family": {
        "value": "Inter UI",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "Inter UI"
        },
        "name": "FontH70Family",
        "attributes": {
          "category": "font",
          "type": "h70",
          "item": "family"
        },
        "path": [
          "font",
          "h70",
          "family"
        ]
      },
      "size": {
        "value": "10px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "10px"
        },
        "name": "FontH70Size",
        "attributes": {
          "category": "font",
          "type": "h70",
          "item": "size"
        },
        "path": [
          "font",
          "h70",
          "size"
        ]
      },
      "weight": {
        "value": "700",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "700"
        },
        "name": "FontH70Weight",
        "attributes": {
          "category": "font",
          "type": "h70",
          "item": "weight"
        },
        "path": [
          "font",
          "h70",
          "weight"
        ]
      },
      "lineHeight": {
        "value": "13px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "13px"
        },
        "name": "FontH70LineHeight",
        "attributes": {
          "category": "font",
          "type": "h70",
          "item": "lineHeight"
        },
        "path": [
          "font",
          "h70",
          "lineHeight"
        ]
      },
      "letterSpacing": {
        "value": "0.25px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "0.25px"
        },
        "name": "FontH70LetterSpacing",
        "attributes": {
          "category": "font",
          "type": "h70",
          "item": "letterSpacing"
        },
        "path": [
          "font",
          "h70",
          "letterSpacing"
        ]
      }
    },
    "h80": {
      "family": {
        "value": "Inter UI",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "Inter UI"
        },
        "name": "FontH80Family",
        "attributes": {
          "category": "font",
          "type": "h80",
          "item": "family"
        },
        "path": [
          "font",
          "h80",
          "family"
        ]
      },
      "size": {
        "value": "12px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "12px"
        },
        "name": "FontH80Size",
        "attributes": {
          "category": "font",
          "type": "h80",
          "item": "size"
        },
        "path": [
          "font",
          "h80",
          "size"
        ]
      },
      "weight": {
        "value": "600",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "600"
        },
        "name": "FontH80Weight",
        "attributes": {
          "category": "font",
          "type": "h80",
          "item": "weight"
        },
        "path": [
          "font",
          "h80",
          "weight"
        ]
      },
      "lineHeight": {
        "value": "16px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "16px"
        },
        "name": "FontH80LineHeight",
        "attributes": {
          "category": "font",
          "type": "h80",
          "item": "lineHeight"
        },
        "path": [
          "font",
          "h80",
          "lineHeight"
        ]
      },
      "letterSpacing": {
        "value": "0",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "0"
        },
        "name": "FontH80LetterSpacing",
        "attributes": {
          "category": "font",
          "type": "h80",
          "item": "letterSpacing"
        },
        "path": [
          "font",
          "h80",
          "letterSpacing"
        ]
      }
    },
    "h90": {
      "family": {
        "value": "Inter UI",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "Inter UI"
        },
        "name": "FontH90Family",
        "attributes": {
          "category": "font",
          "type": "h90",
          "item": "family"
        },
        "path": [
          "font",
          "h90",
          "family"
        ]
      },
      "size": {
        "value": "14px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "14px"
        },
        "name": "FontH90Size",
        "attributes": {
          "category": "font",
          "type": "h90",
          "item": "size"
        },
        "path": [
          "font",
          "h90",
          "size"
        ]
      },
      "weight": {
        "value": "500",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "500"
        },
        "name": "FontH90Weight",
        "attributes": {
          "category": "font",
          "type": "h90",
          "item": "weight"
        },
        "path": [
          "font",
          "h90",
          "weight"
        ]
      },
      "lineHeight": {
        "value": "19px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "19px"
        },
        "name": "FontH90LineHeight",
        "attributes": {
          "category": "font",
          "type": "h90",
          "item": "lineHeight"
        },
        "path": [
          "font",
          "h90",
          "lineHeight"
        ]
      },
      "letterSpacing": {
        "value": "-.50px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "-.50px"
        },
        "name": "FontH90LetterSpacing",
        "attributes": {
          "category": "font",
          "type": "h90",
          "item": "letterSpacing"
        },
        "path": [
          "font",
          "h90",
          "letterSpacing"
        ]
      }
    },
    "h100": {
      "family": {
        "value": "Inter UI",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "Inter UI"
        },
        "name": "FontH100Family",
        "attributes": {
          "category": "font",
          "type": "h100",
          "item": "family"
        },
        "path": [
          "font",
          "h100",
          "family"
        ]
      },
      "size": {
        "value": "16px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "16px"
        },
        "name": "FontH100Size",
        "attributes": {
          "category": "font",
          "type": "h100",
          "item": "size"
        },
        "path": [
          "font",
          "h100",
          "size"
        ]
      },
      "weight": {
        "value": "600",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "600"
        },
        "name": "FontH100Weight",
        "attributes": {
          "category": "font",
          "type": "h100",
          "item": "weight"
        },
        "path": [
          "font",
          "h100",
          "weight"
        ]
      },
      "lineHeight": {
        "value": "22px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "22px"
        },
        "name": "FontH100LineHeight",
        "attributes": {
          "category": "font",
          "type": "h100",
          "item": "lineHeight"
        },
        "path": [
          "font",
          "h100",
          "lineHeight"
        ]
      },
      "letterSpacing": {
        "value": "-.85px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "-.85px"
        },
        "name": "FontH100LetterSpacing",
        "attributes": {
          "category": "font",
          "type": "h100",
          "item": "letterSpacing"
        },
        "path": [
          "font",
          "h100",
          "letterSpacing"
        ]
      }
    },
    "h200": {
      "family": {
        "value": "Inter UI",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "Inter UI"
        },
        "name": "FontH200Family",
        "attributes": {
          "category": "font",
          "type": "h200",
          "item": "family"
        },
        "path": [
          "font",
          "h200",
          "family"
        ]
      },
      "size": {
        "value": "18px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "18px"
        },
        "name": "FontH200Size",
        "attributes": {
          "category": "font",
          "type": "h200",
          "item": "size"
        },
        "path": [
          "font",
          "h200",
          "size"
        ]
      },
      "weight": {
        "value": "600",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "600"
        },
        "name": "FontH200Weight",
        "attributes": {
          "category": "font",
          "type": "h200",
          "item": "weight"
        },
        "path": [
          "font",
          "h200",
          "weight"
        ]
      },
      "lineHeight": {
        "value": "24px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "24px"
        },
        "name": "FontH200LineHeight",
        "attributes": {
          "category": "font",
          "type": "h200",
          "item": "lineHeight"
        },
        "path": [
          "font",
          "h200",
          "lineHeight"
        ]
      },
      "letterSpacing": {
        "value": "-.75px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "-.75px"
        },
        "name": "FontH200LetterSpacing",
        "attributes": {
          "category": "font",
          "type": "h200",
          "item": "letterSpacing"
        },
        "path": [
          "font",
          "h200",
          "letterSpacing"
        ]
      }
    },
    "h300": {
      "family": {
        "value": "Inter UI",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "Inter UI"
        },
        "name": "FontH300Family",
        "attributes": {
          "category": "font",
          "type": "h300",
          "item": "family"
        },
        "path": [
          "font",
          "h300",
          "family"
        ]
      },
      "size": {
        "value": "21px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "21px"
        },
        "name": "FontH300Size",
        "attributes": {
          "category": "font",
          "type": "h300",
          "item": "size"
        },
        "path": [
          "font",
          "h300",
          "size"
        ]
      },
      "weight": {
        "value": "700",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "700"
        },
        "name": "FontH300Weight",
        "attributes": {
          "category": "font",
          "type": "h300",
          "item": "weight"
        },
        "path": [
          "font",
          "h300",
          "weight"
        ]
      },
      "lineHeight": {
        "value": "28px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "28px"
        },
        "name": "FontH300LineHeight",
        "attributes": {
          "category": "font",
          "type": "h300",
          "item": "lineHeight"
        },
        "path": [
          "font",
          "h300",
          "lineHeight"
        ]
      },
      "letterSpacing": {
        "value": "-.50px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "-.50px"
        },
        "name": "FontH300LetterSpacing",
        "attributes": {
          "category": "font",
          "type": "h300",
          "item": "letterSpacing"
        },
        "path": [
          "font",
          "h300",
          "letterSpacing"
        ]
      }
    },
    "h400": {
      "family": {
        "value": "Inter UI",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "Inter UI"
        },
        "name": "FontH400Family",
        "attributes": {
          "category": "font",
          "type": "h400",
          "item": "family"
        },
        "path": [
          "font",
          "h400",
          "family"
        ]
      },
      "size": {
        "value": "24px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "24px"
        },
        "name": "FontH400Size",
        "attributes": {
          "category": "font",
          "type": "h400",
          "item": "size"
        },
        "path": [
          "font",
          "h400",
          "size"
        ]
      },
      "weight": {
        "value": "700",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "700"
        },
        "name": "FontH400Weight",
        "attributes": {
          "category": "font",
          "type": "h400",
          "item": "weight"
        },
        "path": [
          "font",
          "h400",
          "weight"
        ]
      },
      "lineHeight": {
        "value": "32px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "32px"
        },
        "name": "FontH400LineHeight",
        "attributes": {
          "category": "font",
          "type": "h400",
          "item": "lineHeight"
        },
        "path": [
          "font",
          "h400",
          "lineHeight"
        ]
      },
      "letterSpacing": {
        "value": "-.25px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "-.25px"
        },
        "name": "FontH400LetterSpacing",
        "attributes": {
          "category": "font",
          "type": "h400",
          "item": "letterSpacing"
        },
        "path": [
          "font",
          "h400",
          "letterSpacing"
        ]
      }
    },
    "h500": {
      "family": {
        "value": "Inter UI",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "Inter UI"
        },
        "name": "FontH500Family",
        "attributes": {
          "category": "font",
          "type": "h500",
          "item": "family"
        },
        "path": [
          "font",
          "h500",
          "family"
        ]
      },
      "size": {
        "value": "32px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "32px"
        },
        "name": "FontH500Size",
        "attributes": {
          "category": "font",
          "type": "h500",
          "item": "size"
        },
        "path": [
          "font",
          "h500",
          "size"
        ]
      },
      "weight": {
        "value": "700",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "700"
        },
        "name": "FontH500Weight",
        "attributes": {
          "category": "font",
          "type": "h500",
          "item": "weight"
        },
        "path": [
          "font",
          "h500",
          "weight"
        ]
      },
      "lineHeight": {
        "value": "40px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "40px"
        },
        "name": "FontH500LineHeight",
        "attributes": {
          "category": "font",
          "type": "h500",
          "item": "lineHeight"
        },
        "path": [
          "font",
          "h500",
          "lineHeight"
        ]
      },
      "letterSpacing": {
        "value": "0",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "0"
        },
        "name": "FontH500LetterSpacing",
        "attributes": {
          "category": "font",
          "type": "h500",
          "item": "letterSpacing"
        },
        "path": [
          "font",
          "h500",
          "letterSpacing"
        ]
      }
    },
    "h600": {
      "family": {
        "value": "Inter UI",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "Inter UI"
        },
        "name": "FontH600Family",
        "attributes": {
          "category": "font",
          "type": "h600",
          "item": "family"
        },
        "path": [
          "font",
          "h600",
          "family"
        ]
      },
      "size": {
        "value": "48px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "48px"
        },
        "name": "FontH600Size",
        "attributes": {
          "category": "font",
          "type": "h600",
          "item": "size"
        },
        "path": [
          "font",
          "h600",
          "size"
        ]
      },
      "weight": {
        "value": "800",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "800"
        },
        "name": "FontH600Weight",
        "attributes": {
          "category": "font",
          "type": "h600",
          "item": "weight"
        },
        "path": [
          "font",
          "h600",
          "weight"
        ]
      },
      "lineHeight": {
        "value": "60px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "60px"
        },
        "name": "FontH600LineHeight",
        "attributes": {
          "category": "font",
          "type": "h600",
          "item": "lineHeight"
        },
        "path": [
          "font",
          "h600",
          "lineHeight"
        ]
      },
      "letterSpacing": {
        "value": ".25px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": ".25px"
        },
        "name": "FontH600LetterSpacing",
        "attributes": {
          "category": "font",
          "type": "h600",
          "item": "letterSpacing"
        },
        "path": [
          "font",
          "h600",
          "letterSpacing"
        ]
      }
    }
  },
  "spacing": {
    "v0": {
      "value": 0,
      "filePath": "tokens/base/spacing.json",
      "isSource": true,
      "original": {
        "value": 0
      },
      "name": "SpacingV0",
      "attributes": {
        "category": "spacing",
        "type": "v0"
      },
      "path": [
        "spacing",
        "v0"
      ]
    },
    "v50": {
      "value": 4,
      "filePath": "tokens/base/spacing.json",
      "isSource": true,
      "original": {
        "value": 4
      },
      "name": "SpacingV50",
      "attributes": {
        "category": "spacing",
        "type": "v50"
      },
      "path": [
        "spacing",
        "v50"
      ]
    },
    "v100": {
      "value": 8,
      "filePath": "tokens/base/spacing.json",
      "isSource": true,
      "original": {
        "value": 8
      },
      "name": "SpacingV100",
      "attributes": {
        "category": "spacing",
        "type": "v100"
      },
      "path": [
        "spacing",
        "v100"
      ]
    },
    "v200": {
      "value": 16,
      "filePath": "tokens/base/spacing.json",
      "isSource": true,
      "original": {
        "value": 16
      },
      "name": "SpacingV200",
      "attributes": {
        "category": "spacing",
        "type": "v200"
      },
      "path": [
        "spacing",
        "v200"
      ]
    },
    "v300": {
      "value": 24,
      "filePath": "tokens/base/spacing.json",
      "isSource": true,
      "original": {
        "value": 24
      },
      "name": "SpacingV300",
      "attributes": {
        "category": "spacing",
        "type": "v300"
      },
      "path": [
        "spacing",
        "v300"
      ]
    },
    "v400": {
      "value": 32,
      "filePath": "tokens/base/spacing.json",
      "isSource": true,
      "original": {
        "value": 32
      },
      "name": "SpacingV400",
      "attributes": {
        "category": "spacing",
        "type": "v400"
      },
      "path": [
        "spacing",
        "v400"
      ]
    },
    "v500": {
      "value": 48,
      "filePath": "tokens/base/spacing.json",
      "isSource": true,
      "original": {
        "value": 48
      },
      "name": "SpacingV500",
      "attributes": {
        "category": "spacing",
        "type": "v500"
      },
      "path": [
        "spacing",
        "v500"
      ]
    },
    "v600": {
      "value": 64,
      "filePath": "tokens/base/spacing.json",
      "isSource": true,
      "original": {
        "value": 64
      },
      "name": "SpacingV600",
      "attributes": {
        "category": "spacing",
        "type": "v600"
      },
      "path": [
        "spacing",
        "v600"
      ]
    }
  },
  "box": {
    "backgroundColor": {
      "value": "#ffffff",
      "filePath": "tokens/components/box.json",
      "isSource": true,
      "original": {
        "value": "{color.base.white}"
      },
      "name": "BoxBackgroundColor",
      "attributes": {
        "category": "box",
        "type": "backgroundColor"
      },
      "path": [
        "box",
        "backgroundColor"
      ]
    },
    "border": {
      "radius": {
        "value": "4px",
        "filePath": "tokens/components/box.json",
        "isSource": true,
        "original": {
          "value": "{border.round.hairline.radius}"
        },
        "name": "BoxBorderRadius",
        "attributes": {
          "category": "box",
          "type": "border",
          "item": "radius"
        },
        "path": [
          "box",
          "border",
          "radius"
        ]
      },
      "width": {
        "value": "1px",
        "filePath": "tokens/components/box.json",
        "isSource": true,
        "original": {
          "value": "{border.round.hairline.width}"
        },
        "name": "BoxBorderWidth",
        "attributes": {
          "category": "box",
          "type": "border",
          "item": "width"
        },
        "path": [
          "box",
          "border",
          "width"
        ]
      }
    }
  },
  "button": {
    "border": {
      "radius": {
        "value": "4px",
        "filePath": "tokens/components/button.json",
        "isSource": true,
        "original": {
          "value": "{border.round.radius}"
        },
        "name": "ButtonBorderRadius",
        "attributes": {
          "category": "button",
          "type": "border",
          "item": "radius"
        },
        "path": [
          "button",
          "border",
          "radius"
        ]
      },
      "width": {
        "value": "2px",
        "filePath": "tokens/components/button.json",
        "isSource": true,
        "original": {
          "value": "{border.round.width}"
        },
        "name": "ButtonBorderWidth",
        "attributes": {
          "category": "button",
          "type": "border",
          "item": "width"
        },
        "path": [
          "button",
          "border",
          "width"
        ]
      }
    },
    "padding": {
      "vertical": {
        "value": 4,
        "filePath": "tokens/components/button.json",
        "isSource": true,
        "original": {
          "value": "{spacing.v50}"
        },
        "name": "ButtonPaddingVertical",
        "attributes": {
          "category": "button",
          "type": "padding",
          "item": "vertical"
        },
        "path": [
          "button",
          "padding",
          "vertical"
        ]
      },
      "horizontal": {
        "value": 16,
        "filePath": "tokens/components/button.json",
        "isSource": true,
        "original": {
          "value": "{spacing.v200}"
        },
        "name": "ButtonPaddingHorizontal",
        "attributes": {
          "category": "button",
          "type": "padding",
          "item": "horizontal"
        },
        "path": [
          "button",
          "padding",
          "horizontal"
        ]
      }
    },
    "primary": {
      "foregroundColor": {
        "default": {
          "value": "#ffffff",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.white}"
          },
          "name": "ButtonPrimaryForegroundColorDefault",
          "attributes": {
            "category": "button",
            "type": "primary",
            "item": "foregroundColor",
            "subitem": "default"
          },
          "path": [
            "button",
            "primary",
            "foregroundColor",
            "default"
          ]
        },
        "disabled": {
          "value": "#9295a6",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.gray.v200}"
          },
          "name": "ButtonPrimaryForegroundColorDisabled",
          "attributes": {
            "category": "button",
            "type": "primary",
            "item": "foregroundColor",
            "subitem": "disabled"
          },
          "path": [
            "button",
            "primary",
            "foregroundColor",
            "disabled"
          ]
        },
        "hover": {
          "value": "#f9fbff",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.gray.v25}"
          },
          "name": "ButtonPrimaryForegroundColorHover",
          "attributes": {
            "category": "button",
            "type": "primary",
            "item": "foregroundColor",
            "subitem": "hover"
          },
          "path": [
            "button",
            "primary",
            "foregroundColor",
            "hover"
          ]
        },
        "pressed": {
          "value": "#f9fbff",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.gray.v25}"
          },
          "name": "ButtonPrimaryForegroundColorPressed",
          "attributes": {
            "category": "button",
            "type": "primary",
            "item": "foregroundColor",
            "subitem": "pressed"
          },
          "path": [
            "button",
            "primary",
            "foregroundColor",
            "pressed"
          ]
        },
        "error": {
          "value": "#f9fbff",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.gray.v25}"
          },
          "name": "ButtonPrimaryForegroundColorError",
          "attributes": {
            "category": "button",
            "type": "primary",
            "item": "foregroundColor",
            "subitem": "error"
          },
          "path": [
            "button",
            "primary",
            "foregroundColor",
            "error"
          ]
        }
      },
      "backgroundColor": {
        "default": {
          "value": "#0a7db3",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.digitalSecondary.v300}"
          },
          "name": "ButtonPrimaryBackgroundColorDefault",
          "attributes": {
            "category": "button",
            "type": "primary",
            "item": "backgroundColor",
            "subitem": "default"
          },
          "path": [
            "button",
            "primary",
            "backgroundColor",
            "default"
          ]
        },
        "disabled": {
          "value": "#e7efff",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.blue.v50}"
          },
          "name": "ButtonPrimaryBackgroundColorDisabled",
          "attributes": {
            "category": "button",
            "type": "primary",
            "item": "backgroundColor",
            "subitem": "disabled"
          },
          "path": [
            "button",
            "primary",
            "backgroundColor",
            "disabled"
          ]
        },
        "hover": {
          "value": "#005176",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.blue.v500}"
          },
          "name": "ButtonPrimaryBackgroundColorHover",
          "attributes": {
            "category": "button",
            "type": "primary",
            "item": "backgroundColor",
            "subitem": "hover"
          },
          "path": [
            "button",
            "primary",
            "backgroundColor",
            "hover"
          ]
        },
        "pressed": {
          "value": "#384152",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.graySemantic.v500}"
          },
          "name": "ButtonPrimaryBackgroundColorPressed",
          "attributes": {
            "category": "button",
            "type": "primary",
            "item": "backgroundColor",
            "subitem": "pressed"
          },
          "path": [
            "button",
            "primary",
            "backgroundColor",
            "pressed"
          ]
        },
        "error": {
          "value": "#bf1313",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.red.v500}"
          },
          "name": "ButtonPrimaryBackgroundColorError",
          "attributes": {
            "category": "button",
            "type": "primary",
            "item": "backgroundColor",
            "subitem": "error"
          },
          "path": [
            "button",
            "primary",
            "backgroundColor",
            "error"
          ]
        }
      },
      "borderColor": {
        "default": {
          "value": "#0a7db3",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.digitalSecondary.v300}"
          },
          "name": "ButtonPrimaryBorderColorDefault",
          "attributes": {
            "category": "button",
            "type": "primary",
            "item": "borderColor",
            "subitem": "default"
          },
          "path": [
            "button",
            "primary",
            "borderColor",
            "default"
          ]
        },
        "disabled": {
          "value": "#e7efff",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.blue.v50}"
          },
          "name": "ButtonPrimaryBorderColorDisabled",
          "attributes": {
            "category": "button",
            "type": "primary",
            "item": "borderColor",
            "subitem": "disabled"
          },
          "path": [
            "button",
            "primary",
            "borderColor",
            "disabled"
          ]
        },
        "hover": {
          "value": "#005176",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.blue.v500}"
          },
          "name": "ButtonPrimaryBorderColorHover",
          "attributes": {
            "category": "button",
            "type": "primary",
            "item": "borderColor",
            "subitem": "hover"
          },
          "path": [
            "button",
            "primary",
            "borderColor",
            "hover"
          ]
        },
        "pressed": {
          "value": "#384152",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.graySemantic.v500}"
          },
          "name": "ButtonPrimaryBorderColorPressed",
          "attributes": {
            "category": "button",
            "type": "primary",
            "item": "borderColor",
            "subitem": "pressed"
          },
          "path": [
            "button",
            "primary",
            "borderColor",
            "pressed"
          ]
        },
        "error": {
          "value": "#bf1313",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.red.v500}"
          },
          "name": "ButtonPrimaryBorderColorError",
          "attributes": {
            "category": "button",
            "type": "primary",
            "item": "borderColor",
            "subitem": "error"
          },
          "path": [
            "button",
            "primary",
            "borderColor",
            "error"
          ]
        }
      }
    },
    "secondary": {
      "foregroundColor": {
        "default": {
          "value": "#25252c",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.gray.v800}"
          },
          "name": "ButtonSecondaryForegroundColorDefault",
          "attributes": {
            "category": "button",
            "type": "secondary",
            "item": "foregroundColor",
            "subitem": "default"
          },
          "path": [
            "button",
            "secondary",
            "foregroundColor",
            "default"
          ]
        },
        "disabled": {
          "value": "#abadba",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.gray.v100}"
          },
          "name": "ButtonSecondaryForegroundColorDisabled",
          "attributes": {
            "category": "button",
            "type": "secondary",
            "item": "foregroundColor",
            "subitem": "disabled"
          },
          "path": [
            "button",
            "secondary",
            "foregroundColor",
            "disabled"
          ]
        },
        "hover": {
          "value": "#25252c",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.gray.v800}"
          },
          "name": "ButtonSecondaryForegroundColorHover",
          "attributes": {
            "category": "button",
            "type": "secondary",
            "item": "foregroundColor",
            "subitem": "hover"
          },
          "path": [
            "button",
            "secondary",
            "foregroundColor",
            "hover"
          ]
        },
        "pressed": {
          "value": "#25252c",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.gray.v800}"
          },
          "name": "ButtonSecondaryForegroundColorPressed",
          "attributes": {
            "category": "button",
            "type": "secondary",
            "item": "foregroundColor",
            "subitem": "pressed"
          },
          "path": [
            "button",
            "secondary",
            "foregroundColor",
            "pressed"
          ]
        },
        "error": {
          "value": "#bf1313",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.red.v500}"
          },
          "name": "ButtonSecondaryForegroundColorError",
          "attributes": {
            "category": "button",
            "type": "secondary",
            "item": "foregroundColor",
            "subitem": "error"
          },
          "path": [
            "button",
            "secondary",
            "foregroundColor",
            "error"
          ]
        }
      },
      "backgroundColor": {
        "default": {
          "value": "#ffffff",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.white}"
          },
          "name": "ButtonSecondaryBackgroundColorDefault",
          "attributes": {
            "category": "button",
            "type": "secondary",
            "item": "backgroundColor",
            "subitem": "default"
          },
          "path": [
            "button",
            "secondary",
            "backgroundColor",
            "default"
          ]
        },
        "disabled": {
          "value": "#ffffff",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.white}"
          },
          "name": "ButtonSecondaryBackgroundColorDisabled",
          "attributes": {
            "category": "button",
            "type": "secondary",
            "item": "backgroundColor",
            "subitem": "disabled"
          },
          "path": [
            "button",
            "secondary",
            "backgroundColor",
            "disabled"
          ]
        },
        "hover": {
          "value": "#e9ecf3",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.gray.v50}"
          },
          "name": "ButtonSecondaryBackgroundColorHover",
          "attributes": {
            "category": "button",
            "type": "secondary",
            "item": "backgroundColor",
            "subitem": "hover"
          },
          "path": [
            "button",
            "secondary",
            "backgroundColor",
            "hover"
          ]
        },
        "pressed": {
          "value": "#d7dae2",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.gray.v75}"
          },
          "name": "ButtonSecondaryBackgroundColorPressed",
          "attributes": {
            "category": "button",
            "type": "secondary",
            "item": "backgroundColor",
            "subitem": "pressed"
          },
          "path": [
            "button",
            "secondary",
            "backgroundColor",
            "pressed"
          ]
        },
        "error": {
          "value": "#ffffff",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.white}"
          },
          "name": "ButtonSecondaryBackgroundColorError",
          "attributes": {
            "category": "button",
            "type": "secondary",
            "item": "backgroundColor",
            "subitem": "error"
          },
          "path": [
            "button",
            "secondary",
            "backgroundColor",
            "error"
          ]
        }
      },
      "borderColor": {
        "default": {
          "value": "#e9ecf3",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.gray.v50}"
          },
          "name": "ButtonSecondaryBorderColorDefault",
          "attributes": {
            "category": "button",
            "type": "secondary",
            "item": "borderColor",
            "subitem": "default"
          },
          "path": [
            "button",
            "secondary",
            "borderColor",
            "default"
          ]
        },
        "disabled": {
          "value": "#e7efff",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.blue.v50}"
          },
          "name": "ButtonSecondaryBorderColorDisabled",
          "attributes": {
            "category": "button",
            "type": "secondary",
            "item": "borderColor",
            "subitem": "disabled"
          },
          "path": [
            "button",
            "secondary",
            "borderColor",
            "disabled"
          ]
        },
        "hover": {
          "value": "#e9ecf3",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.gray.v50}"
          },
          "name": "ButtonSecondaryBorderColorHover",
          "attributes": {
            "category": "button",
            "type": "secondary",
            "item": "borderColor",
            "subitem": "hover"
          },
          "path": [
            "button",
            "secondary",
            "borderColor",
            "hover"
          ]
        },
        "pressed": {
          "value": "#d7dae2",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.gray.v75}"
          },
          "name": "ButtonSecondaryBorderColorPressed",
          "attributes": {
            "category": "button",
            "type": "secondary",
            "item": "borderColor",
            "subitem": "pressed"
          },
          "path": [
            "button",
            "secondary",
            "borderColor",
            "pressed"
          ]
        },
        "error": {
          "value": "#bf1313",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.red.v500}"
          },
          "name": "ButtonSecondaryBorderColorError",
          "attributes": {
            "category": "button",
            "type": "secondary",
            "item": "borderColor",
            "subitem": "error"
          },
          "path": [
            "button",
            "secondary",
            "borderColor",
            "error"
          ]
        }
      }
    },
    "default": {
      "foregroundColor": {
        "default": {
          "value": "#25252c",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.gray.v800}"
          },
          "name": "ButtonDefaultForegroundColorDefault",
          "attributes": {
            "category": "button",
            "type": "default",
            "item": "foregroundColor",
            "subitem": "default"
          },
          "path": [
            "button",
            "default",
            "foregroundColor",
            "default"
          ]
        },
        "disabled": {
          "value": "#abadba",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.gray.v100}"
          },
          "name": "ButtonDefaultForegroundColorDisabled",
          "attributes": {
            "category": "button",
            "type": "default",
            "item": "foregroundColor",
            "subitem": "disabled"
          },
          "path": [
            "button",
            "default",
            "foregroundColor",
            "disabled"
          ]
        },
        "hover": {
          "value": "#25252c",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.gray.v800}"
          },
          "name": "ButtonDefaultForegroundColorHover",
          "attributes": {
            "category": "button",
            "type": "default",
            "item": "foregroundColor",
            "subitem": "hover"
          },
          "path": [
            "button",
            "default",
            "foregroundColor",
            "hover"
          ]
        },
        "pressed": {
          "value": "#25252c",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.gray.v800}"
          },
          "name": "ButtonDefaultForegroundColorPressed",
          "attributes": {
            "category": "button",
            "type": "default",
            "item": "foregroundColor",
            "subitem": "pressed"
          },
          "path": [
            "button",
            "default",
            "foregroundColor",
            "pressed"
          ]
        },
        "error": {
          "value": "#bf1313",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.red.v500}"
          },
          "name": "ButtonDefaultForegroundColorError",
          "attributes": {
            "category": "button",
            "type": "default",
            "item": "foregroundColor",
            "subitem": "error"
          },
          "path": [
            "button",
            "default",
            "foregroundColor",
            "error"
          ]
        }
      },
      "backgroundColor": {
        "default": {
          "value": "#ffffff",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.white}"
          },
          "name": "ButtonDefaultBackgroundColorDefault",
          "attributes": {
            "category": "button",
            "type": "default",
            "item": "backgroundColor",
            "subitem": "default"
          },
          "path": [
            "button",
            "default",
            "backgroundColor",
            "default"
          ]
        },
        "disabled": {
          "value": "#ffffff",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.white}"
          },
          "name": "ButtonDefaultBackgroundColorDisabled",
          "attributes": {
            "category": "button",
            "type": "default",
            "item": "backgroundColor",
            "subitem": "disabled"
          },
          "path": [
            "button",
            "default",
            "backgroundColor",
            "disabled"
          ]
        },
        "hover": {
          "value": "#e9ecf3",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.gray.v50}"
          },
          "name": "ButtonDefaultBackgroundColorHover",
          "attributes": {
            "category": "button",
            "type": "default",
            "item": "backgroundColor",
            "subitem": "hover"
          },
          "path": [
            "button",
            "default",
            "backgroundColor",
            "hover"
          ]
        },
        "pressed": {
          "value": "#d7dae2",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.gray.v75}"
          },
          "name": "ButtonDefaultBackgroundColorPressed",
          "attributes": {
            "category": "button",
            "type": "default",
            "item": "backgroundColor",
            "subitem": "pressed"
          },
          "path": [
            "button",
            "default",
            "backgroundColor",
            "pressed"
          ]
        },
        "error": {
          "value": "#ffffff",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.white}"
          },
          "name": "ButtonDefaultBackgroundColorError",
          "attributes": {
            "category": "button",
            "type": "default",
            "item": "backgroundColor",
            "subitem": "error"
          },
          "path": [
            "button",
            "default",
            "backgroundColor",
            "error"
          ]
        }
      },
      "borderColor": {
        "default": {
          "value": "#e9ecf3",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.gray.v50}"
          },
          "name": "ButtonDefaultBorderColorDefault",
          "attributes": {
            "category": "button",
            "type": "default",
            "item": "borderColor",
            "subitem": "default"
          },
          "path": [
            "button",
            "default",
            "borderColor",
            "default"
          ]
        },
        "disabled": {
          "value": "#e7efff",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.blue.v50}"
          },
          "name": "ButtonDefaultBorderColorDisabled",
          "attributes": {
            "category": "button",
            "type": "default",
            "item": "borderColor",
            "subitem": "disabled"
          },
          "path": [
            "button",
            "default",
            "borderColor",
            "disabled"
          ]
        },
        "hover": {
          "value": "#e9ecf3",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.gray.v50}"
          },
          "name": "ButtonDefaultBorderColorHover",
          "attributes": {
            "category": "button",
            "type": "default",
            "item": "borderColor",
            "subitem": "hover"
          },
          "path": [
            "button",
            "default",
            "borderColor",
            "hover"
          ]
        },
        "pressed": {
          "value": "#d7dae2",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.gray.v75}"
          },
          "name": "ButtonDefaultBorderColorPressed",
          "attributes": {
            "category": "button",
            "type": "default",
            "item": "borderColor",
            "subitem": "pressed"
          },
          "path": [
            "button",
            "default",
            "borderColor",
            "pressed"
          ]
        },
        "error": {
          "value": "#bf1313",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.red.v500}"
          },
          "name": "ButtonDefaultBorderColorError",
          "attributes": {
            "category": "button",
            "type": "default",
            "item": "borderColor",
            "subitem": "error"
          },
          "path": [
            "button",
            "default",
            "borderColor",
            "error"
          ]
        }
      }
    },
    "icon": {
      "foregroundColor": {
        "default": {
          "value": "#25252c",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.gray.v800}"
          },
          "name": "ButtonIconForegroundColorDefault",
          "attributes": {
            "category": "button",
            "type": "icon",
            "item": "foregroundColor",
            "subitem": "default"
          },
          "path": [
            "button",
            "icon",
            "foregroundColor",
            "default"
          ]
        },
        "disabled": {
          "value": "#abadba",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.gray.v100}"
          },
          "name": "ButtonIconForegroundColorDisabled",
          "attributes": {
            "category": "button",
            "type": "icon",
            "item": "foregroundColor",
            "subitem": "disabled"
          },
          "path": [
            "button",
            "icon",
            "foregroundColor",
            "disabled"
          ]
        },
        "hover": {
          "value": "#25252c",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.gray.v800}"
          },
          "name": "ButtonIconForegroundColorHover",
          "attributes": {
            "category": "button",
            "type": "icon",
            "item": "foregroundColor",
            "subitem": "hover"
          },
          "path": [
            "button",
            "icon",
            "foregroundColor",
            "hover"
          ]
        },
        "pressed": {
          "value": "#25252c",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.gray.v800}"
          },
          "name": "ButtonIconForegroundColorPressed",
          "attributes": {
            "category": "button",
            "type": "icon",
            "item": "foregroundColor",
            "subitem": "pressed"
          },
          "path": [
            "button",
            "icon",
            "foregroundColor",
            "pressed"
          ]
        },
        "error": {
          "value": "#bf1313",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.red.v500}"
          },
          "name": "ButtonIconForegroundColorError",
          "attributes": {
            "category": "button",
            "type": "icon",
            "item": "foregroundColor",
            "subitem": "error"
          },
          "path": [
            "button",
            "icon",
            "foregroundColor",
            "error"
          ]
        }
      },
      "backgroundColor": {
        "default": {
          "value": "#ffffff",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.white}"
          },
          "name": "ButtonIconBackgroundColorDefault",
          "attributes": {
            "category": "button",
            "type": "icon",
            "item": "backgroundColor",
            "subitem": "default"
          },
          "path": [
            "button",
            "icon",
            "backgroundColor",
            "default"
          ]
        },
        "disabled": {
          "value": "#ffffff",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.white}"
          },
          "name": "ButtonIconBackgroundColorDisabled",
          "attributes": {
            "category": "button",
            "type": "icon",
            "item": "backgroundColor",
            "subitem": "disabled"
          },
          "path": [
            "button",
            "icon",
            "backgroundColor",
            "disabled"
          ]
        },
        "hover": {
          "value": "#e9ecf3",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.gray.v50}"
          },
          "name": "ButtonIconBackgroundColorHover",
          "attributes": {
            "category": "button",
            "type": "icon",
            "item": "backgroundColor",
            "subitem": "hover"
          },
          "path": [
            "button",
            "icon",
            "backgroundColor",
            "hover"
          ]
        },
        "pressed": {
          "value": "#d7dae2",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.gray.v75}"
          },
          "name": "ButtonIconBackgroundColorPressed",
          "attributes": {
            "category": "button",
            "type": "icon",
            "item": "backgroundColor",
            "subitem": "pressed"
          },
          "path": [
            "button",
            "icon",
            "backgroundColor",
            "pressed"
          ]
        },
        "error": {
          "value": "#ffffff",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.white}"
          },
          "name": "ButtonIconBackgroundColorError",
          "attributes": {
            "category": "button",
            "type": "icon",
            "item": "backgroundColor",
            "subitem": "error"
          },
          "path": [
            "button",
            "icon",
            "backgroundColor",
            "error"
          ]
        }
      },
      "borderColor": {
        "default": {
          "value": "#ffffff",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.white}"
          },
          "name": "ButtonIconBorderColorDefault",
          "attributes": {
            "category": "button",
            "type": "icon",
            "item": "borderColor",
            "subitem": "default"
          },
          "path": [
            "button",
            "icon",
            "borderColor",
            "default"
          ]
        },
        "disabled": {
          "value": "#e7efff",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.blue.v50}"
          },
          "name": "ButtonIconBorderColorDisabled",
          "attributes": {
            "category": "button",
            "type": "icon",
            "item": "borderColor",
            "subitem": "disabled"
          },
          "path": [
            "button",
            "icon",
            "borderColor",
            "disabled"
          ]
        },
        "hover": {
          "value": "#e9ecf3",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.gray.v50}"
          },
          "name": "ButtonIconBorderColorHover",
          "attributes": {
            "category": "button",
            "type": "icon",
            "item": "borderColor",
            "subitem": "hover"
          },
          "path": [
            "button",
            "icon",
            "borderColor",
            "hover"
          ]
        },
        "pressed": {
          "value": "#d7dae2",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.gray.v75}"
          },
          "name": "ButtonIconBorderColorPressed",
          "attributes": {
            "category": "button",
            "type": "icon",
            "item": "borderColor",
            "subitem": "pressed"
          },
          "path": [
            "button",
            "icon",
            "borderColor",
            "pressed"
          ]
        },
        "error": {
          "value": "#bf1313",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.red.v500}"
          },
          "name": "ButtonIconBorderColorError",
          "attributes": {
            "category": "button",
            "type": "icon",
            "item": "borderColor",
            "subitem": "error"
          },
          "path": [
            "button",
            "icon",
            "borderColor",
            "error"
          ]
        }
      }
    }
  },
  "focusRing": {
    "outline": {
      "color": {
        "value": "#a0bdf8",
        "filePath": "tokens/components/focusRing.json",
        "isSource": true,
        "original": {
          "value": "{color.base.blue.v100}"
        },
        "name": "FocusRingOutlineColor",
        "attributes": {
          "category": "focusRing",
          "type": "outline",
          "item": "color"
        },
        "path": [
          "focusRing",
          "outline",
          "color"
        ]
      },
      "width": {
        "value": "2px",
        "filePath": "tokens/components/focusRing.json",
        "isSource": true,
        "original": {
          "value": "2px"
        },
        "name": "FocusRingOutlineWidth",
        "attributes": {
          "category": "focusRing",
          "type": "outline",
          "item": "width"
        },
        "path": [
          "focusRing",
          "outline",
          "width"
        ]
      },
      "offset": {
        "value": "2px",
        "filePath": "tokens/components/focusRing.json",
        "isSource": true,
        "original": {
          "value": "2px"
        },
        "name": "FocusRingOutlineOffset",
        "attributes": {
          "category": "focusRing",
          "type": "outline",
          "item": "offset"
        },
        "path": [
          "focusRing",
          "outline",
          "offset"
        ]
      }
    }
  },
  "link": {
    "foregroundColor": {
      "default": {
        "value": "#0a7db3",
        "filePath": "tokens/components/link.json",
        "isSource": true,
        "original": {
          "value": "{color.base.digitalSecondary.v300}"
        },
        "name": "LinkForegroundColorDefault",
        "attributes": {
          "category": "link",
          "type": "foregroundColor",
          "item": "default"
        },
        "path": [
          "link",
          "foregroundColor",
          "default"
        ]
      },
      "disabled": {
        "value": "#d7dae2",
        "filePath": "tokens/components/link.json",
        "isSource": true,
        "original": {
          "value": "{color.base.gray.v75}"
        },
        "name": "LinkForegroundColorDisabled",
        "attributes": {
          "category": "link",
          "type": "foregroundColor",
          "item": "disabled"
        },
        "path": [
          "link",
          "foregroundColor",
          "disabled"
        ]
      },
      "hover": {
        "value": "#0a7db3",
        "filePath": "tokens/components/link.json",
        "isSource": true,
        "original": {
          "value": "{color.base.digitalSecondary.v300}"
        },
        "name": "LinkForegroundColorHover",
        "attributes": {
          "category": "link",
          "type": "foregroundColor",
          "item": "hover"
        },
        "path": [
          "link",
          "foregroundColor",
          "hover"
        ]
      },
      "pressed": {
        "value": "#005176",
        "filePath": "tokens/components/link.json",
        "isSource": true,
        "original": {
          "value": "{color.base.blue.v500}"
        },
        "name": "LinkForegroundColorPressed",
        "attributes": {
          "category": "link",
          "type": "foregroundColor",
          "item": "pressed"
        },
        "path": [
          "link",
          "foregroundColor",
          "pressed"
        ]
      }
    }
  }
};